import { useCallback } from 'react'
import { useIsUnmounted, useNotification } from '@/hooks'
import { PreferencesFormValues } from '../../types'
import { selectTerritoryId, updateNotificationConfig } from '@/features/domain/territory'
import { useAppDispatch } from '@/store'
import { useSelector } from 'react-redux'
import { useEditingStateWithCtx } from '@/atoms'

export function useOnSubmit() {
  const isUnmounted = useIsUnmounted()
  const dispatch = useAppDispatch()
  const territoryId = useSelector(selectTerritoryId)
  const toast = useNotification()
  const { resetEditing } = useEditingStateWithCtx('customerNotifications')

  return useCallback(
    async (formValues: PreferencesFormValues) => {
      try {
        const result = await dispatch(
          updateNotificationConfig({ territoryId, notificationConfig: formValues }),
        )

        if (!updateNotificationConfig.fulfilled.match(result)) {
          throw new Error(result.payload?.message ?? 'Internal error')
        }

        if (isUnmounted()) return

        // if the update has been completed successfully let's close the form
        resetEditing()
      } catch (error) {
        toast.error(error.message)

        if (isUnmounted()) return
      }
    },
    [isUnmounted, dispatch, territoryId, toast, resetEditing],
  )
}
